export default {
  log_signin: 'Sign in',
  log_dont_have_an_account: 'Don\'t have an account?',
  log_register_now: 'Register now',
  log_forgot_password: 'Forgot your password?',
  log_recover_it: 'Recover it'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/login_view.js